import React from 'react';

import '../../styles/components/options/editButton.scss';
import editBtn from '../../assets/edit_pencil.svg';

export default function EditButton({ handleEditState }) {
	return (
		<div className='edit_button_wrapper' onClick={() => handleEditState()}>
			<div className='edit_button_container'>
				<img src={editBtn} alt='' />
			</div>
		</div>
	);
}
